import { ReactNode, useEffect } from "react";
import {
  Navigate,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

import ROUTES from "shared/routes";
import { MainLayout } from "widgets/main-layout";

export const RequireAuth = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const ref = searchParams.get("ref");
    if (ref) {
      localStorage.setItem("bind-companies-ref", ref);
      if (localStorage.getItem("token")) {
        navigate(ROUTES.COMPANIES_BIND);
      } else {
        navigate(`${ROUTES.LOGIN}?${searchParams.toString()}`);
      }
    }
  }, [searchParams, navigate]);

  if (!token) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return <MainLayout>{children}</MainLayout>;
};
